import React, { useState } from 'react'
import ProfDashboardLayout from './ProfDashboardLayout'
import DownloadButtons from '../../../components/downloadButtons/DownloadButtons';
import AllSettings from '../../../components/allSettings/AllSettings';

const ProfessionalSettings = () => {

    const [showPass, setShowPass] = useState(false);
    const [changeCards, setChangeCards] = useState("")

    const passwordHideShow = () => {
        setShowPass(!showPass);
    }

    return (
        <>
            <ProfDashboardLayout>
                <AllSettings/>
            </ProfDashboardLayout>
        </>
    )
}

export default ProfessionalSettings